import { Component, Vue } from 'vue-property-decorator'
import CAIG0050Service from './CAIG0050Service'
import CAIG0050ViewModel from './CAIG0050ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import CommonConstants from '@/common/CommonConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent, fixedContentNoLogin } from '@/assets/js/main.js'
import { DigitalBookButton } from '@/common/utils/modules-util'

@Component({
  name: 'CAIG0050',
  components: {}
  })
export default class CAIG0050Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private caig0050Service = new CAIG0050Service()
  private caig0050ViewModel: CAIG0050ViewModel = {
    callCenterUsageGuideInfo: {
      content: ''
    },
    batchDispDiv: ''
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    fixedContentNoLogin()
    await this.init()
    this.$nextTick(() => {
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const caia0050ResponseModel = await this.caig0050Service.callAPICAIA0050()

    if (CommonUtil.isNotEmpty(caia0050ResponseModel.callCenterUsageGuideInfo)) {
      this.caig0050ViewModel.callCenterUsageGuideInfo.content =
        CommonUtil.replacePathCMS(
          caia0050ResponseModel.callCenterUsageGuideInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caia0050ResponseModel.callCenterUsageGuideInfo.path
        )
    } else {
      this.caig0050ViewModel.callCenterUsageGuideInfo = null
    }
    this.caig0050ViewModel.batchDispDiv = caia0050ResponseModel.batchDispDiv
  }

  /**
   * 前に戻るボタン押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
